



















































  import {
    format,
  } from 'date-fns'
  import Vue from 'vue'
  import {
    Component,
    Prop
  } from 'vue-property-decorator'
  import Subscription, { StripeUpcomingInvoice } from '../../../api/v2/models/subscription'

  @Component({})
  export default class SubscriptionComponent extends Vue {
    @Prop({
      required: true
    })
    subscription: Subscription

    @Prop({
      required: false,
      default: null
    })
    stripeUpcomingInvoice: StripeUpcomingInvoice | null

    get nextPaymentDate() {
      if (this.stripeUpcomingInvoice && this.stripeUpcomingInvoice.nextPaymentAttempt) {
        return this.dateFormat(this.stripeUpcomingInvoice.nextPaymentAttempt)
      }
      return null
    }

    dateFormat(date: Date) {
      return format(date, 'YYYY/MM/DD')
    }

    mounted() {
      console.log('Subscription type:', {
        type: this.subscription.purchaseType,
        isLifeTime: this.subscription.isLifeTime,
        isEachMonth: this.subscription.isEachMonth
      });
    }
  }
